// @flow
import { KEY } from './constants'
export const email = (state: Object) => state[KEY].email
export const isCoTrustee = (state: Object) => state[KEY].isCoTrustee
export const isAuditor = (state: Object) => state[KEY].isAuditor
export const isLoggedIn = (state: Object) => state[KEY].isLoggedIn
export const isFeeScheduleAdmin = (state: Object) => state[KEY].isFeeScheduleAdmin
export const isStatusAdmin = (state: Object) => state[KEY].isStatusAdmin
export const getNewUser = (state: Object) => state[KEY].newUser

export const getUser = (state: Object) => state[KEY].user

export const getUsers = (state: Object) => state[KEY].users

export const getUserRoles = (state: Object) => {
  const user = getUser(state)
  if (user && user.roles) {
    return user.roles.map((role) => role.type || role)
  }

  const roles = localStorage.getItem('roles')
  return roles ? roles.split(',') : []
}
